import type {
  PaginatedRecordsResponseDTO,
  RecordsFiltersDTO,
} from "@/application/records/dtos/RecordListItemDTO";
import type { RecordsGatewayPort } from "@/application/records/ports/RecordsGatewayPort";

export interface FetchAdminRecordsPaginatedInputDto {
  page: number;
  limit: number;
  filters?: RecordsFiltersDTO;
}

/**
 * Use case: загрузка админских записей с серверной пагинацией и фильтрами.
 */
export class FetchAdminRecordsPaginatedUseCase {
  constructor(private readonly gateway: RecordsGatewayPort) {}

  async execute(
    input: FetchAdminRecordsPaginatedInputDto
  ): Promise<PaginatedRecordsResponseDTO> {
    const { page, limit, filters } = input;
    return this.gateway.getAdminRecordsPaginated(page, limit, filters);
  }
}
